module.exports = __webpack_public_path__ + "img/play.678a618b.svg";